import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, Subject, tap } from 'rxjs';
import { ApiConstants } from '../../shared/constants/api-constants';
import { Delegate } from '../models/delegate';
import { DelegatToUpdate } from '../../delegate/models/updateDelegate';

@Injectable({
  providedIn: 'root'
})
export class DelegationService {

  delegateLookUpData = {}

  constructor(private httpClient: HttpClient) { }

  getDelegateLookUpDetails(): Observable<any> {
    let observable: Observable<any>;
    if (Object.keys(this.delegateLookUpData).length === 0) {
      observable = this.httpClient
        .get(ApiConstants.Delegate_LookUp_API)
        .pipe(tap((delegateData) => (this.delegateLookUpData = delegateData)));
    } else {
      observable = of(this.delegateLookUpData);
    }
    return observable;
  }

  saveDelegateDetails(payload: Delegate): Observable<any> {
    return this.httpClient.post(ApiConstants.Delegate_Save_api, payload)
  }
  updateDelegation(payload: DelegatToUpdate): Observable<any> {
    return this.httpClient.post(ApiConstants.Delegate_update_api, payload)
  }
  getLatestDocumentDetail(documentNumberList: string[]): Observable<any> {
    return this.httpClient.post(ApiConstants.Get_List_Of_DocumentLatestVersion_Api,documentNumberList);
  }

  getDelegationsForMyDelegationTab(isActive:boolean):Observable<any>{
    return this.httpClient.get(ApiConstants.Delegate_GetDelegatesForMyDelegationsTab_api + "/"+`${isActive}`);
  }
  
  getDelegationsForMeTab(isActive:boolean):Observable<any>{
    return this.httpClient.get(ApiConstants.Delegate_GetDelegatesForMe + "/" + `${isActive}`);
  }
  updateEndDelegation(payload: String[]):Observable<any>{
    return this.httpClient.put(ApiConstants.Delegate_updateEndDelegation_api, payload);
  }

  checkAccessibility = (): Observable<any>=>{
    return this.httpClient.get(ApiConstants.Delegate_CheckAccessibilityForLoggedInUser);
  }
}

